'use strict';

var MemberApp = angular.module('MemberApp');

MemberApp.controller('PensionSummaryCtrl', function(PensionSummaryStore, $scope) {

  this.loadingState = PensionSummaryStore.getLoadingState();
  this.pensionSummary = PensionSummaryStore.getPensionSummary();

  let unique = PensionSummaryStore.onUpdate('PensionModulesCtrl', () => {
    this.loadingState = PensionSummaryStore.getLoadingState();
    this.pensionSummary = PensionSummaryStore.getPensionSummary();
  }, false, true);

  this.showInitialPensionAndInflation = function() {
    return this.pensionSummary.hasInflation &&
           !this.pensionSummary.differedPension &&
           !this.pensionSummary.hasBridgeBenefit;
  };

  $scope.$on('$destroy', function() {
    PensionSummaryStore.deregister(unique);
  });
});
